import clsx from 'clsx';

import { Tag } from '@/components/Tag';
import type { CandidateRecipient } from '../lib/recipients';

type MailRecipientChipsProps = {
  recipients: CandidateRecipient[];
  className?: string;
};

export default function MailRecipientChips({ recipients, className }: MailRecipientChipsProps) {
  return (
    <div
      className={clsx(
        'hidden-scrollbar flex min-w-0 items-center overflow-x-auto overflow-y-hidden',
        className
      )}
    >
      {recipients.map((recipient) => (
        <Tag key={recipient.id} color="blue" size="sm" className="shrink-0">
          {recipient.name}
        </Tag>
      ))}
    </div>
  );
}
